import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';
import { CustomPropertyDataType } from './const/enums';

export class LinkedCustomProperty extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.caption = dataContext.Caption;
      this.customPropertyId = dataContext.customProperty;
      this.boolValue = dataContext.boolValue;
      this.mandatory = false;
      this.textValue = dataContext.textValue;
      this.numericValue = dataContext.numericValue;
      this.decimalCount = dataContext.decimalCount;
      this.dateValue = dataContext.dateValue;
      this.selectableValues = dataContext.selectableValues;
      this.dataType = dataContext.dataType;
    }
  }
  caption: string;
  customPropertyId: string;
  boolValue: boolean;
  mandatory: boolean;
  textValue: string;
  numericValue: number;
  decimalCount: number;
  dateValue: LocalDate;
  selectableValues: string[];
  dataType: CustomPropertyDataType;
  toJSON() {
    return {
      id: this.id,
      customPropertyId: this.customPropertyId,
      boolValue: this.boolValue,
      mandatory: this.mandatory,
      textValue: this.textValue,
      numericValue: this.numericValue,
      decimalCount: this.decimalCount,
      dateValue: this.dateValue,
      selectableValues: this.selectableValues,
      dataType: this.dataType,
    };
  }
}
